"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _formUrlencoded = _interopRequireDefault(require("form-urlencoded"));

var KlaviyoStatesNewsletterForm = /*#__PURE__*/function () {
  function KlaviyoStatesNewsletterForm(component) {
    (0, _classCallCheck2["default"])(this, KlaviyoStatesNewsletterForm);
    this.dom = {
      $component: component,
      $title: component.querySelector('.js-klaviyo-states-newsletter-title'),
      $subtitle: component.querySelector('.js-klaviyo-states-newsletter-subtitle'),
      $form: component.querySelector('.js-klaviyo-states-newsletter-form'),
      $input: component.querySelector('.js-klaviyo-states-newsletter-form-email')
    }, this.state = {
      state: false,
      loading: false,
      removeForm: component.dataset.removeForm ? true : false,
      removeValidation: component.dataset.removeValidation ? true : false,
      stateTimeout: 5000
    };
    this.submitHandler = this.subscribe.bind(this);
    this.blurHandler = this.checkInvalid.bind(this);
    this.invalidHandler = this.setInvalid.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(KlaviyoStatesNewsletterForm, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : connect', this);
      dom.$form.addEventListener('submit', this.submitHandler);

      if (state.removeValidation) {
        dom.$input.addEventListener('blur', this.blurHandler);
        dom.$input.addEventListener('invalid', this.invalidHandler);
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : unmount', this);
      dom.$form.removeEventListener('submit', this.submitHandler);

      if (state.removeValidation) {
        dom.$input.removeEventListener('blur', this.blurHandler);
        dom.$input.removeEventListener('invalid', this.invalidHandler);
      }
    }
  }, {
    key: "formToObject",
    value: function formToObject() {
      var dom = this.dom,
          state = this.state;
      var object = Array.from(dom.$form.elements).reduce(function (data, element) {
        data[element.name] = element.value;
        return data;
      }, {});
      return object;
    }
  }, {
    key: "subscribe",
    value: function subscribe(event) {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : subscribe', this, event);
      event.preventDefault();
      event.stopPropagation();
      var self = this;
      var ajaxUrl = dom.$form.dataset.ajaxUrl;
      var data = this.formToObject();
      (0, _axios["default"])({
        method: 'post',
        url: ajaxUrl,
        data: (0, _formUrlencoded["default"])(data)
      }).then(function (response) {
        // handle success
        if (response.data.success) {
          console.log('success', response);
          self.setMessages('success');

          if (state.removeForm) {
            self.removeForm();
          } else {
            self.reset();
            setTimeout(function () {
              self.setMessages('reset');
            }, state.stateTimeout * 2);
          }
        }
      })["catch"](function (response) {
        // handle error
        console.log('error', response);
        self.setMessages('error');
        self.reset();
        setTimeout(function () {
          self.setMessages('reset');
        }, state.stateTimeout);
      });
    }
  }, {
    key: "setMessages",
    value: function setMessages(key) {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : setMessages', this, key);
      [dom.$title, dom.$subtitle].forEach(function (element, index) {
        if (element) {
          var value = element.dataset[key] || false;

          if (value) {
            element.innerText = value;
          }
        }
      });
      dom.$component.classList.remove("is-".concat(state.state));
      dom.$component.classList.add("is-".concat(key));
      state.state = key;
    }
  }, {
    key: "checkInvalid",
    value: function checkInvalid(event) {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : checkInvalid', this);
      var valid = dom.$input.checkValidity();

      if (valid) {
        dom.$component.classList.remove("is-invalid");
      }
    }
  }, {
    key: "setInvalid",
    value: function setInvalid(event) {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : setInvalid', this);
      event.preventDefault();
      event.stopPropagation();
      dom.$component.classList.add("is-invalid");
    }
  }, {
    key: "removeForm",
    value: function removeForm() {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : removeForm', this);
      dom.$form.parentNode.removeChild(dom.$form);
    }
  }, {
    key: "reset",
    value: function reset() {
      var dom = this.dom,
          state = this.state;
      console.log('KlaviyoStatesNewsletterForm : reset', this);
      dom.$form.reset();
    }
  }]);
  return KlaviyoStatesNewsletterForm;
}();

exports["default"] = KlaviyoStatesNewsletterForm;